import { useEffect } from 'react';
import API from '../../../utils/api';
import { useExitRoute } from './use-exit-route';

// Hook para limpiar instancia de BC Kambi
export const useKambiClean = (isLoggedAndBootstrapReady) => {
  // Función para limpiar Kambi
  const cleanupKambi = async () => {
    try {
      // Limpiar instancia de Kambi si existe
      if (window?._kbc && typeof window?._kbc?.dispose === 'function') {
        await window._kbc.dispose();
        if (isLoggedAndBootstrapReady) {
          await API.kambyInvalidateTickets();
        }
        setTimeout(() => {
          window?._kbc?.dispose();
          const kambiCdnScripts = document.querySelectorAll('script[src*="kambicdn"]');

          // Itera y elimina cada uno
          kambiCdnScripts.forEach(script => {
            script.remove();
          });
        }, 2000);
      }

      // Limpiar referencias globales incluso si no hay instancia completa
      if (window._kbc) {
        delete window._kbc;
      }

      // Limpiar el contenedor si existe
      const kambiBCElement = document.getElementById('KambiBC');
      if (kambiBCElement) {
        kambiBCElement.innerHTML = '';
      }
    } catch (error) {
      console.error('Error al limpiar Kambi:', error);
      // Forzar limpieza de referencias incluso si hay error
      if (window._kbc) {
        delete window._kbc;
      }
    }
  };

  // Detectar cambios de ruta y limpiar Kambi si se navega fuera de Kambi
  useExitRoute({
    onExit: cleanupKambi,
  });

  useEffect(() => {
    return () => {
      cleanupKambi();
    };
  }, []);

  return cleanupKambi;
};
